import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { PreEnrolledAccountsService } from '../pre-enrolled-accounts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { finalize } from 'rxjs';
import { IPreInrolatAddPayload } from '../pre-enrolled-accounts.interface';

@Component({
    selector: 'app-add-pre-inrolat',
    templateUrl: './add-pre-inrolat.component.html',
    styleUrls: ['./add-pre-inrolat.component.scss']
})
export class AddPreInrolatComponent {
    // general error
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    token!: string;
    isLoading = false;
    form: FormGroup = new FormGroup({
        persoana_id: new FormControl('', []),
        nume: new FormControl('', [Validators.required]),
        prenume: new FormControl('', [Validators.required]),
        telefon: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required]),
        cnp: new FormControl('', []),
        cui: new FormControl('', []),
        // active: new FormControl(true, []),
        // confirmed: new FormControl('', []),
        // confirmed_source: new FormControl('', []),
        // id_cetatean_m: new FormControl('', []),
        pin: new FormControl('', []),
        f_nume: new FormControl('', []),
        f_reg_com: new FormControl('', [])
    });

    constructor(
        private dialogRef: MatDialogRef<AddPreInrolatComponent>,
        private preEnrolledAccountsService: PreEnrolledAccountsService,
        private notificationService: NotificationService,
        private authService: AuthService,
    ) {
        this.processToken();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.preEnrolledAccountsService.setToken(token);
        });
    }

    submitForm() {
        this.isLoading = true;

        const newPreInrolat: IPreInrolatAddPayload = {
            persoana_id: this.form.get('persoana_id')?.value,
            nume: this.form.get('nume')?.value,
            prenume: this.form.get('prenume')?.value,
            telefon: this.form.get('telefon')?.value,
            email: this.form.get('email')?.value,
            cnp: this.form.get('cnp')?.value,
            cui: this.form.get('cui')?.value,
            // active: this.form.get('active')?.value,
            // confirmed: this.form.get('confirmed')?.value,
            // confirmed_source: this.form.get('confirmed_source')?.value,
            // id_cetatean_m: this.form.get('id_cetatean_m')?.value,
            pin: this.form.get('pin')?.value,
            f_nume: this.form.get('f_nume')?.value,
            f_reg_com: this.form.get('f_reg_com')?.value,
        };

        this.preEnrolledAccountsService
            .addPreInrolat(newPreInrolat)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let errorMessage =
                        environment.config.customNotifications.generalMessages.error;
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                },
            });
    }
}
